export function FinalCTA() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-b from-black via-[#0F0F0F] to-black py-32 overflow-hidden">
      {/* Glow Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[120px]"></div>
      <div className="absolute top-20 right-20 w-[400px] h-[400px] bg-[#D4AF37]/3 rounded-full blur-[100px]"></div>
      
      <div className="relative max-w-[900px] mx-auto px-8 text-center">
        <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-6">
          Ready to Launch?
        </div>
        
        <h2 className="text-white text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Your Story Deserves to Be Published
        </h2>
        
        <p className="text-[#999999] text-xl mb-12 max-w-[700px] mx-auto leading-relaxed">
          Let's build a book that opens doors, builds authority, and creates long-term value for your brand.
        </p>
        
        <div className="flex flex-wrap gap-5 justify-center">
          <button
            onClick={scrollToContact}
            className="bg-[#D4AF37] text-black px-10 py-4 rounded-full text-base font-semibold hover:brightness-110 transition-all shadow-lg shadow-[#D4AF37]/20 whitespace-nowrap cursor-pointer"
          >
            Book a Free Strategy Call
          </button>
          
          <button
            onClick={scrollToContact}
            className="bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] px-10 py-4 rounded-full text-base font-semibold hover:bg-[#D4AF37] hover:text-black transition-all whitespace-nowrap cursor-pointer"
          >
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
}